import { Injectable } from '@angular/core';

import { DataEntity, DataEntityDto } from '@osos/shared/api';

import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import {
  DataEntityPresenterModel,
  ReactionDataEntityPresenterModel,
} from '@osos/shared/types';
import { EntityParserV1Service } from '../../parsers';

@Injectable()
export class EntityFactoryService extends FactoryBase<
  DataEntity,
  DataEntityPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: EntityParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: DataEntityPresenterModel): DataEntity {
    const parser = this.getParser(
      DataEntity,
      DataEntityPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: Partial<DataEntity & DataEntityDto>,
  ): DataEntityPresenterModel {
    const parser = this.getParser(
      DataEntity,
      DataEntityPresenterModel,
      model.specificationVersion,
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }

  createPresenterModelForReactionEntity(
    model: Partial<DataEntity & DataEntityDto>,
  ) {
    const parser = this.getParser(
      DataEntity,
      ReactionDataEntityPresenterModel,
      model.specificationVersion,
    ) as EntityParserV1Service;
    const result = parser?.getPresenterModelForReactionEntity(model);
    return result;
  }
}
